import { parseISO, startOfDay } from 'date-fns';
import schedulePageActions from './schedulePageActions';
import { createReducer } from '@reduxjs/toolkit';
import { SCHEDULE_DAY_VIEWS, SCHEDULE_VIEW_TYPES } from 'pages/ScheduleV6/constants/constants';
import { adaptedDataHelper } from './schedulePageOperation';

const initialState = {
  loading: 0,
  selectedDate: sessionStorage.getItem('scheduleDate')
    ? parseISO(sessionStorage.getItem('scheduleDate'))
    : startOfDay(new Date()),
  resources: {
    allWorkers: null,
    equipment: null,
    workers: null,
  },
  filters: {},
  filterOptions: { contractors: [], projects: [], projectTypes: [] },
  sheets: [],
  calendarEvents: [],
  scheduleDayView: SCHEDULE_DAY_VIEWS.time,
  scheduleView: SCHEDULE_VIEW_TYPES.daily,
  monthSheets: {},
  weekSheets: {},
  availability: {
    timeoffs: [],
    calendarEvents: [],
    holidays: [],
    assignedWorkers: [],
    assignedEquipment: [],
  },
  selectedResources: {
    sheetId: null,
    workers: [],
    equipment: [],
  },
  showAllLocations: false,
  searchValue: '',
};

const schedule =  createReducer(initialState, {
    [schedulePageActions.setLoading]: (state, { payload }) => ({
      ...state,
      loading: payload ? state.loading + 1 : (state.loading || 1) - 1,
    }),
    [schedulePageActions.setResourcesEquipment]: (state, { payload }) => ({
      ...state,
      resources: { ...state.resources, equipment: payload },
    }),
    [schedulePageActions.setResourcesWorkers]: (state, { payload }) => ({
      ...state,
      resources: { ...state.resources, workers: payload },
    }),
    [schedulePageActions.setResourcesAllWorkers]: (state, { payload }) => ({
      ...state,
      resources: { ...state.resources, allWorkers: payload },
    }),
    [schedulePageActions.addWorker]: (state, { payload }) => ({
      ...state,
      resources: {
        ...state.resources,
        workers: [...state.resources.workers, payload],
      }
    }),
    [schedulePageActions.addToAllWorkers]: (state, { payload }) => ({
      ...state,
      resources: {
        ...state.resources,
        allWorkers: [...state.resources.allWorkers, payload],
      }
    }),
    [schedulePageActions.updateWorkerResource]: (state, { payload }) => ({
      ...state,
      resources: {
        ...state.resources,
        workers: state.resources.workers.map(
          (worker) => (
            worker._id === payload._id
              ? { ...worker, profile: { ...worker.profile, ...(payload.profile || {}) } }
              : worker
          )
        ),
        allWorkers: state.resources.allWorkers.map(
          (worker) => (
            worker._id === payload._id
              ? { ...worker, profile: { ...worker.profile, ...(payload.profile || {}) } }
              : worker
          )
        ),
      }
    }),
    [schedulePageActions.removeWorkerResource]: (state, { payload }) => ({
      ...state,
      resources: {
        ...state.resources,
        workers: [...state.resources.workers.filter(worker => worker._id !== payload._id)],
      }
    }),
    [schedulePageActions.setSheets]: (state, { payload }) => ({
      ...state,
      sheets: payload,
    }),
    [schedulePageActions.setMonthSheets]: (state, { payload }) => {

      return {
        ...state,
        monthSheets: payload,
      };
    },
    [schedulePageActions.setWeekSheets]: (state, { payload }) => ({
      ...state,
      weekSheets: payload,
    }),
    [schedulePageActions.addSheetToMonthSchedule]: (state, { payload }) => {
      const updatedMonthSheets = { ...state.monthSheets };
      const { dateKey, data } = payload;
    
      const updatedData = updatedMonthSheets[dateKey] ? [...updatedMonthSheets[dateKey], data] : [data];

      return {
        ...state,
        monthSheets: {
          ...updatedMonthSheets,
          [dateKey]: updatedData,
        },
      };
    },
    [schedulePageActions.removeSheetFromMonthSchedule]: (state, { payload }) => {// _id
      const filteredData = {};

      for (const key in state.monthSheets) {
        if (Object.hasOwnProperty.call(state.monthSheets, key)) {
          filteredData[key] = state.monthSheets[key].filter(obj => obj._id != payload);
        }
      }

      return {
        ...state,
        monthSheets: filteredData
      };
    },
    [schedulePageActions.updateMonthSheet]: (state, { payload }) => {
      const updatedMonthSheets = { ...state.monthSheets };
    
      for (const key in updatedMonthSheets) {
        const array = updatedMonthSheets[key];
        const updatedArray = array.map(obj => {
          if (obj._id === payload._id) {
            return { ...obj, ...payload };
          }
          return obj;
        });
    
        updatedMonthSheets[key] = updatedArray;
      }
    
      return {
        ...state,
        monthSheets: updatedMonthSheets,
      };
    },
    [schedulePageActions.updateCrewLeaderMonthCalendar]: (state, { payload }) => {
      const updatedMonthSheets = { ...state.monthSheets };
    
      for (const key in updatedMonthSheets) {
        const array = updatedMonthSheets[key];
        const updatedArray = array.map(obj => {
          if (obj._id === payload._id) {
            return { ...obj, workers: obj.workers.map(worker => {
              if (worker._id !== payload.workerId) return worker;
              return {...worker, foreman: payload.foreman}
            }) };
          }
          return obj;
        });
    
        updatedMonthSheets[key] = updatedArray;
      }
    
      return {
        ...state,
        monthSheets: updatedMonthSheets,
      };
    },
    
    [schedulePageActions.setFilters]: (state, { payload }) => ({ ...state, filters: payload }),
    [schedulePageActions.setFilterOptions]: (state, { payload }) => ({
      ...state,
      filterOptions: { ...state.filterOptions, ...payload },
    }),
    [schedulePageActions.setSelectedDate]: (state, { payload }) => ({
      ...state,
      selectedDate: payload,
      sheets: initialState.sheets,
    }),
    [schedulePageActions.setCrewLeaderAction]: (state, { payload }) => {
      const newSheets = state.sheets.map((el) => {
        if (el.sheet._id === payload.sheetId) {
          // el.workers.find((el) => el._id === payload.workerId).foreman = payload.isForeman;
          // el.sheet.unpublishedChanges = true;
          const newWorkersArr = el.workers.map(worker=>{
            if (worker._id === payload.workerId){
              return {...worker, foreman: payload.isForeman, }
            }
            return worker
          })
          return {...el, workers:newWorkersArr, sheet: {...el.sheet, unpublishedChanges: true}}
        }
        return el;
      });
      return { ...state, sheets: newSheets };
    },
    [schedulePageActions.moveWorkers]: (state, { payload }) => {
      const newSheets = state.sheets.map((scheduleSheet) => {
        const updatedSheet = payload.find((sheet) => sheet._id === scheduleSheet.sheet._id);
        return updatedSheet
          ? {
              ...scheduleSheet,
              sheet: {
                ...scheduleSheet.sheet,
                workers: updatedSheet.workers,
              },
              workers: updatedSheet.workers,
              noWorkers: updatedSheet.workers.length === 0,
            }
          : scheduleSheet;
      });

      return { ...state, sheets: newSheets };
    },
    [schedulePageActions.moveEquipment]: (state, { payload }) => {
      const newSheets = state.sheets.map((scheduleSheet) => {
        const newSheet =
        payload.fromId && scheduleSheet.sheet._id === payload.fromId
            ? {
                ...scheduleSheet,
                equipment: scheduleSheet.equipment.filter((e) => e._id !== payload.equipmentId),
              }
            : scheduleSheet;
        const updatedSheet = payload.data.find((sheet) => sheet._id === newSheet.sheet._id);
        return updatedSheet
          ? {
              ...scheduleSheet,
              sheet: {
                ...scheduleSheet.sheet,
                equipment: updatedSheet.equipment,
              },
              equipment: updatedSheet.equipment,
            }
          : newSheet;
      });

      return { ...state, sheets: newSheets };
    },
    [schedulePageActions.updateSheet]: (state, { payload }) => {
      const newSheets = state.sheets.map((scheduleSheet) =>
        (scheduleSheet.sheet._id === payload._id)
          ? adaptedDataHelper([{ ...scheduleSheet?.sheet, ...payload }])?.[0]
          : scheduleSheet
      );

      return {
        ...state,
        sheets: newSheets,
      };
    },
    [schedulePageActions.setReturnToShop]: (state, { payload }) => {
      const sheetsThisDay = state.sheets.map((scheduleSheet) =>
        scheduleSheet.sheet._id === payload._id
          ? {
              ...scheduleSheet,
              sheet: {
                ...scheduleSheet.sheet,
                returnToShop: payload.returnToShop,
                unpublishedChanges: true,
              },
            }
          : scheduleSheet
      );
      return {
        ...state,
        sheets: sheetsThisDay,
      };
    },
    [schedulePageActions.updateCrewLeader]: (state, { payload }) => {
      const newSheets = state.sheets.map((el) => {
        if (el.sheet._id === payload._id) {

            const updatedSheet = {
              ...el.sheet,
              workers: el.sheet.workers.map((worker) => {
                if (worker._id === payload.workerId) {
                  return {
                    ...worker,
                    foreman: payload.foreman,
                  };
                }
                return worker;
              }),
              unpublishedChanges: true,
            };
  
            return {
              ...el,
              sheet: updatedSheet,
              workers: el.sheet.workers.map((worker) => {
                if (worker._id === payload.workerId) {
                  return {
                    ...worker,
                    foreman: payload.foreman,
                  };
                }
                return worker;
              }),
            };
          }

        return el;
      });

      return {
        ...state,
        sheets: newSheets,
      };
    },
    [schedulePageActions.updateSheetsEquipment]: (state, { payload }) => {
      const newSheets = state.sheets.map(el => {
        const hasUpdatedEquip = el.sheet.equipment?.some(equip => equip._id === payload._id);
        if (hasUpdatedEquip) {
          el.sheet.equipment = el.sheet.equipment.map(equip => equip._id === payload._id ? ({ ...equip, ...payload }) : equip);
        }
      });

      return {
        ...state,
        sheets: newSheets,
      }
    },
    [schedulePageActions.setSheetCanceled]: (state, { payload }) => {
      const newSheets = state.sheets.map((el) => {
        if (el.sheet._id === payload._id) {
          return {
            ...el,
            sheet: {
              ...el.sheet,
              canceledAt: payload.canceledAt,
              canceledBy: payload.canceledBy,
              cancelNote: payload.cancelNote,
              unpublishedChanges: !el.sheet.unpublishedChanges && !payload.canceledAt
                ? true
                : el.sheet.unpublishedChanges,
            },
          };
        }
        return el;
      });

      return {
        ...state,
        sheets: newSheets,
      };
    },
    [schedulePageActions.setSheetSubmitted]: (state, { payload }) => {
      const newSheets = state.sheets.map((el) => {
        if (el.sheet._id === payload._id) {
          return {
            ...el,
            sheet: {
              ...el.sheet,
              submittedAt: payload.submittedAt,
              submittedBy: payload.submittedBy,
            },
          };
        }
        return el;
      });
      return { ...state, sheets: newSheets };
    },
    [schedulePageActions.unpublishWorklog]: (state, { payload }) => {
      let newSheets = state.sheets;
      let newWeekSheets = { ...state.weekSheets };
      let newMonthSheets = { ...state.monthSheets };

      switch (state.scheduleView) {
        case SCHEDULE_VIEW_TYPES.weekly:
          Object.keys(newWeekSheets).forEach((key) => {
            newWeekSheets[key] = newWeekSheets[key].map((sheet) =>
              sheet._id === payload._id ? { ...sheet, unpublishedChanges: true } : sheet
            );
          });
          break;
        case SCHEDULE_VIEW_TYPES.monthly:
          Object.keys(newMonthSheets).forEach((key) => {
            newMonthSheets[key] = newMonthSheets[key].map((sheet) =>
              sheet._id === payload._id ? { ...sheet, unpublishedChanges: true } : sheet
            );
          });
          break;
        default:
          newSheets = state.sheets.map((el) => {
            if (el.sheet._id === payload._id) {
              return { ...el, sheet: { ...el.sheet, unpublishedChanges: true } };
            }
            return el;
          });
      }

      return {
        ...state,
        sheets: newSheets,
        weekSheets: newWeekSheets,
        monthSheets: newMonthSheets,
      };
    },
    [schedulePageActions.publishWorklogs]: (state, { payload }) => {
      let newSheets = state.sheets;
      let newWeekSheets = { ...state.weekSheets };
      let newMonthSheets = { ...state.monthSheets };
      switch (state.scheduleView) {
        case SCHEDULE_VIEW_TYPES.weekly:
          Object.keys(newWeekSheets).forEach((key) => {
            newWeekSheets[key] = newWeekSheets[key].map(sheet => (
              payload.sheetIds.includes(sheet._id)
                ? ({ ...sheet, published: true, unpublishedChanges: false })
                : sheet
            ))
          });
          break;
        case SCHEDULE_VIEW_TYPES.monthly:
          Object.keys(newMonthSheets).forEach((key) => {
            newMonthSheets[key] = newMonthSheets[key].map(sheet => (
              payload.sheetIds.includes(sheet._id)
                ? ({ ...sheet, published: true, unpublishedChanges: false })
                : sheet
            ))
          });
          break;
        default:
          newSheets = state.sheets.map((el) => {
            if (payload.sheetIds.includes(el.sheet._id)) {
              return {
                ...el,
                sheet: {
                  ...el.sheet,
                  published: true,
                  unpublishedChanges: false,
                }
              }
            }
            return el;
          });
      }

      return {
        ...state,
        sheets: newSheets,
        weekSheets: newWeekSheets,
        monthSheets: newMonthSheets,
      };
    },
    [schedulePageActions.reconcileWorklogs]: (state, { payload }) => {
      // Daily / grid / cl view (wrapped: { _id, sheet: { _id, reconciled } })
      const newSheets = state.sheets.map((el) =>
        payload.sheetIds.includes(el.sheet._id)
          ? { ...el, sheet: { ...el.sheet, reconciled: true } }
          : el
      );

      // Weekly view (raw per dateKey: { _id, reconciled })
      const newWeekSheets = { ...state.weekSheets };
      Object.keys(newWeekSheets).forEach((key) => {
        newWeekSheets[key] = newWeekSheets[key].map((sheet) =>
          payload.sheetIds.includes(sheet._id)
            ? { ...sheet, reconciled: true }
            : sheet
        );
      });

      // Monthly view (raw per dateKey: { _id, reconciled })
      const newMonthSheets = { ...state.monthSheets };
      Object.keys(newMonthSheets).forEach((key) => {
        newMonthSheets[key] = newMonthSheets[key].map((sheet) =>
          payload.sheetIds.includes(sheet._id)
            ? { ...sheet, reconciled: true }
            : sheet
        );
      });

      return { ...state, sheets: newSheets, weekSheets: newWeekSheets, monthSheets: newMonthSheets };
    },
    [schedulePageActions.setGridPosition]: (state, { payload }) => {
      const newSheets = state.sheets.map((el) => {
        if (el.sheet._id === payload._id) {
          const newGrid = { ...el.grid, position: payload.position };
          return {
            ...el,
            grid: { ...newGrid},
            sheet: { ...el.sheet, grid: { ...newGrid } }
          }
        }
        return el;
      });

      return { ...state, sheets: newSheets };
    },
    [schedulePageActions.swapGridsPosition]: (state, { payload }) => {
      const newSheets = state.sheets.map((el) => {
        if (el.sheet._id === payload.swappedGrids[0]._id) {
          return {
            ...el,
            sheet: {
              ...el.sheet,
              grid: { ...el.sheet.grid, position: payload.swappedGrids[0].position },
            },
            grid: { ...el.sheet.grid, position: payload.swappedGrids[0].position }
          };
        }
        if (el.sheet._id === payload.swappedGrids[1]._id) {
          return {
            ...el,
            sheet: {
              ...el.sheet,
              grid: { ...el.sheet.grid, position: payload.swappedGrids[1].position },
            },
            grid: { ...el.sheet.grid, position: payload.swappedGrids[1].position }
          };
        }
        return el;
      });

      return { ...state, sheets: newSheets };
    },
    [schedulePageActions.deleteWorklog]: (state, { payload }) => {
      let newSheets = state.sheets;
      let newWeekSheets = { ...state.weekSheets };
      let newMonthSheets = { ...state.monthSheets };
      switch (state.scheduleView) {
        case SCHEDULE_VIEW_TYPES.weekly:
          Object.keys(newWeekSheets).forEach((key) => {
            newWeekSheets[key] = newWeekSheets[key].filter((el) => el._id !== payload._id)
          });
          break;
        case SCHEDULE_VIEW_TYPES.monthly:
          Object.keys(newMonthSheets).forEach((key) => {
            newMonthSheets[key] = newMonthSheets[key].filter((el) => el._id !== payload._id)
          });
          break;
        default:
          newSheets = state.sheets.filter((el) => el._id !== payload._id);
      }

      return {
        ...state,
        sheets: newSheets,
        weekSheets: newWeekSheets,
        monthSheets: newMonthSheets,
      };
    },
    // Calendar events sockets
    [schedulePageActions.setCalendarEvents]: (state, { payload }) => ({
      ...state,
      calendarEvents: payload,
    }),
    [schedulePageActions.addCalendarEvent]: (state, { payload }) => ({
      ...state,
      calendarEvents: [...state.calendarEvents, payload],
    }),
    [schedulePageActions.removeCalendarEvents]: (state, { payload }) => ({
      ...state,
      calendarEvents: state.calendarEvents.filter(({ _id }) => _id !== payload)
    }),
    [schedulePageActions.setScheduleDayView]: (state, { payload }) => ({
      ...state,
      scheduleDayView: payload,
    }),
    [schedulePageActions.setScheduleView]: (state, { payload }) => ({
      ...state,
      scheduleDayView: payload === SCHEDULE_VIEW_TYPES.daily
        ? state.scheduleDayView || SCHEDULE_DAY_VIEWS.time
        : null,
      scheduleView: payload,
    }),
    [schedulePageActions.setScheduleResourcesAvailability]: (state, { payload }) => ({
      ...state,
      availability: payload,
    }),
    [schedulePageActions.setSelectedResourcesWorklogId]: (state, { payload }) => ({
      ...state,
      selectedResources: {
        ...state.selectedResources,
        sheetId: payload,
        // workers: [],
        // equipment: [],
      }
    }),
    [schedulePageActions.selectWorklogPeopleResource]: (state, { payload }) => {
      const workers = state.selectedResources.workers?.includes(payload)
        ? state.selectedResources.workers.filter(workerId => workerId !== payload)
        : [...state.selectedResources.workers, payload];

      return {
        ...state,
        selectedResources: {
          ...state.selectedResources,
          sheetId: (state.selectedResources.equipment?.length || workers?.length) ? state.selectedResources.sheetId : null,
          workers: workers,
        }
      }
    },
    [schedulePageActions.selectWorklogEquipmentResource]: (state, { payload }) => {
      const equipment = state.selectedResources.equipment?.includes(payload)
        ? state.selectedResources.equipment.filter(equipId => equipId !== payload)
        : [...state.selectedResources.equipment, payload];

      return {
        ...state,
        selectedResources: {
          ...state.selectedResources,
          sheetId: (state.selectedResources.workers?.length || equipment?.length) ? state.selectedResources.sheetId : null,
          equipment: equipment
      }
      }
    },
    [schedulePageActions.setSelectedResources]: (state, { payload }) => ({
      ...state,
      selectedResources: {
        ...state.selectedResources,
        ...payload,
      }
    }),
    [schedulePageActions.deselectAllResources]: (state, { payload }) => ({
      ...state,
      selectedResources: {
        sheetId: null,
        workers: [],
        equipment: [],
      }
    }),
    [schedulePageActions.setShowAllLocations]: (state, { payload }) => ({
      ...state,
      showAllLocations: payload,
    }),
    [schedulePageActions.setSearchValue]: (state, { payload }) => ({
      ...state,
      searchValue: payload,
    }),

    // WEEKLY VIEW ACTIONS

    [schedulePageActions.addSheetToWeekSchedule]: (state, { payload }) => {
      const updatedWeekSheets = { ...state.weekSheets };
      const { dateKey, data } = payload;
    
      const updatedData = updatedWeekSheets[dateKey] ? [...updatedWeekSheets[dateKey], data] : [data];

      return {
        ...state,
        weekSheets: {
          ...updatedWeekSheets,
          [dateKey]: updatedData,
        },
      };
    },
    [schedulePageActions.removeSheetFromWeekSchedule]: (state, { payload }) => {// _id
      const filteredData = {};

      for (const key in state.weekSheets) {
        if (Object.hasOwnProperty(state.weekSheets, key)) {
          filteredData[key] = state.weekSheets[key].filter(obj => obj._id != payload);
        }
      }

      return {
        ...state,
        weekSheets: { ...filteredData },
      };
    },
    [schedulePageActions.updateWeekSheet]: (state, { payload }) => {
      const updatedWeekSheets = { ...state.weekSheets };

      for (const key in updatedWeekSheets) {
        const array = updatedWeekSheets[key];
        const updatedArray = array.map(obj => {
          if (obj._id === payload._id) {
            return { ...obj, ...payload };
          }
          return obj;
        });

        updatedWeekSheets[key] = updatedArray;
      }

      return {
        ...state,
        weekSheets: updatedWeekSheets,
      };
    },
    [schedulePageActions.updateCrewLeaderWeekCalendar]: (state, { payload }) => {
      const updatedWeekSheets = { ...state.weekSheets };
    
      for (const key in updatedWeekSheets) {
        const array = updatedWeekSheets[key];
        const updatedArray = array.map(obj => {
          if (obj._id === payload._id) {
            return { ...obj, workers: obj.workers.map(worker => {
              if (worker._id !== payload.workerId) return worker;
              return {...worker, foreman: payload.foreman}
            }) };
          }
          return obj;
        });
    
        updatedWeekSheets[key] = updatedArray;
      }
    
      return {
        ...state,
        weekSheets: updatedWeekSheets,
      };
    },
  })

export default schedule;
//   const defaultCase = () => state;

//   return (nextState[action.type] || defaultCase)(action.payload);
// };
